{
  "search": "Buscar",
  "completed": "Empresa completa",
  "notCompleted": "Empresa no completada",
  "types": {
    "CORPORATION": "Empresa",
    "LLC": "Sociedad de responsabilidad limitada",
    "PARTNERSHIP": "Asociación",
    "SOLE_PROPRIETORSHIP": "Empresa unipersonal"
  },
  "table": {
    "name": "Nombre de la empresa",
    "primaryContact": "Contacto principal",
    "primaryEmail": "Correo electrónico de contacto principal",
    "numberOfAccounts": "# de cuentas",
    "completedAt": "Completado en ",
    "totalAssets": "Total de activos",
    "organization": "Organización"
  },
  "addModal": {
    "title": "Añadir nueva empresa",
    "name": "Nombre",
    "corporationType": "Tipo de empresa",
    "corporationCountry": "País",
    "createARelation": "Crear una relación",
    "primaryUser": "Usuario principal",
    "organization": "Organización",
    "establishedDate": "Fecha de creación"
  },
  "tooltips": {
    "establishedDate": "Fecha de creación",
    "primaryEmail": "Correo electrónico de contacto principal",
    "physicalAddress": "Dirección"
  },
  "tabs": {
    "overview": "Resumen general",
    "details": "Detalles",
    "affiliates": "Afiliados",
    "documents": "Documentos",
    "statements": "Declaraciones",
    "transfers": "Transferencias",
    "ledger": "Libro mayor",
    "trades": "Transacciones",
    "notes": "Notas"
  },
  "overview": {
    "totalCorporationAssets": "Activos totales de la empresa"
  },
  "details": {
    "accountInformation": "Información de la cuenta",
    "fees": "Tarifas",
    "contactInformation": "Información de contacto",
    "name": "Nombre",
    "esablishedDate": "Fecha de creación",
    "country": "País",
    "address": "Dirección",
    "type": "Tipo",
    "incorporationNumber": "Número de empresa",
    "businessIsMemberOfIiroc": "La empresa es miembro de IIROC",
    "taxNumber": "Número de identificación fiscal de la CRA",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "feeGrid": "Tabla de tarifas",
    "billingCycle": "Ciclo de facturación"
  },
  "edit": {
    "accountInformation": "Información de la cuenta",
    "fees": "Tarifas",
    "contactInformation": "Información de contacto",
    "name": "Nombre",
    "establishedDate": "Fecha de creación",
    "country": "País",
    "physicalAddress": "Dirección",
    "businessType": "Tipo",
    "incorporationNumber": "Número de empresa",
    "businessIsMemberOfIiroc": "La empresa es miembro de IIROC",
    "taxNumber": "Número de identificación fiscal de la CRA",
    "feeTierId": "Tabla de tarifas",
    "billingScheduleId": "Ciclo de facturación",
    "primaryEmail": "Correo electrónico",
    "phone": "Teléfono",
    "businessTypeOptions": {
      "CORPORATION": "Empresa",
      "LLC": "Sociedad de responsabilidad limitada",
      "PARTNERSHIP": "Asociación",
      "SOLE_PROPRIETORSHIP": "Empresa unipersonal"
    },
    "corporationCountry": "País de la empresa",
    "buttons": {
      "updateContactInformation": "Actualizar la información de contacto corporativa",
      "updateFeesInformation": "Actualizar la información sobre las tarifas corporativas",
      "updateAccountInformation": "Actualizar la información de la cuenta corporativa"
    },
    "title": "Actualizar información corporativa"
  }
}
